// UserAbsentItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import util from '../../../lib/util.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class UserAbsentItem extends Component {
  static get propTypes () {
    return {
      absent: PropTypes.object.isRequired,
      onView: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      absent: {},
      onView: null
    }
  }

  render () {
    const absent = this.props.absent
    return (
      <div className='user-absentitem' onClick={this._onView.bind(this)}>
        <div className='itemheader'>
          {absent.fullDay ? (
            <h3 className='title'>
              <IntlMessage ident='user.absent.allDay' />
            </h3>
          ) : (
            <h3 className='title'>
              {util.convertMinutesToHour(absent.fromTime)} -
              {util.convertMinutesToHour(absent.toTime)}
            </h3>
          )}
          <p className='info'>{absent.date}</p>
        </div>
        <div className='itemcontent'>
          <h2>{absent.type}</h2>
        </div>
      </div>
    )
  }

  /* Prublic function */
  _onView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.absent)
    }
  }
}

export default UserAbsentItem
